//dev-epa.info-aid.net/multimedia/photo/1/2/2366_History_1.jpg

https: module.exports = {
	getCategory: function(catId) {
		// console.log('catIdcatId',catId)
    if (catId == 1) {
      return "Dance";
    } else if (catId == 2) {
      return "Film";
    } else if (catId == 3) {
      return "Visual Arts";
    } else if (catId == 4) {
      return "Broadcast Arts";
    } else if (catId == 5) {
      return "Music";
    } else if (catId == 6) {
      return "Literature";
    } else if (catId == 7) {
      return "Theater";
    } else if (catId == 8) {
      return "Architecture";
    } else if (catId == 8) {
      return "Historical";
    } else {
      return "";
    }
	},

  fontSizeOptions: function(style) {
    // console.log("size", size)
    if (style == 1) {
      return "1";
    } else if (style == 2) {
      return "2";
    } else if (style == 3) {
      return "3";
    }else {
      return "";
    }
  },

  fontSizeTitle: function(size) {
    // console.log("size", size)
    if (size == 1) {
      return "font-size-title-1";
    } else if (size == 2) {
      return "font-size-title-2";
    } else if (size == 3) {
      return "font-size-title-3";
    }else {
      return "";
    }
  }, 

  fontSizeCategory:function(size) {
    // console.log("size", size)
    if (size == 1) {
      return "font-size-category-1";
    } else if (size == 2) {
      return "font-size-category-2";
    } else if (size == 3) {
      return "font-size-category-3";
    }else {
      return "";
    }
  },

  fontSizeDesc:function(size) {
    // console.log("size", size)
    if (size == 1) {
      return "font-size-desc-1";
    } else if (size == 2) {
      return "font-size-desc-2";
    } else if (size == 3) {
      return "font-size-desc-3";
    }else {
      return "";
    }
  },

  ImageSizeOptions:function(style) {
    // console.log("size", size)
    if (style == 1) {
      return "image-size-1";
    } else if (style == 2) {
      return "image-size-2";
    } else if (style == 3) {
      return "image-size-3";
    }else {
      return "";
    }
  },

  getMonthName:function(month){
    const d = new Date();
    d.setMonth(month-1);
    const monthName = d.toLocaleString("default", {month: "long"});
    return monthName;
  }
};

